import { render, staticRenderFns } from "./KVPairInfoModal.vue?vue&type=template&id=2776d10f"
import script from "./KVPairInfoModal.vue?vue&type=script&lang=js"
export * from "./KVPairInfoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports